import React, { Component } from "react";
import {getTimeInIST, format, popover, format_date_only, format_fancy} from '../Utils';
import {OverlayTrigger, Glyphicon, Button, Table} from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';
import moment from "moment";
import { UserService } from "../Services/UserService";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "../css/payment_transactions.css"
import { ROLES } from "../Roles";
import { PaymentService } from "../Services/PaymentService";
import CollectPayment from "../CollectPayment";
import XLSX from 'xlsx';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import { RowCountOptions } from "../Config";

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
    },
    tablecell: {
        fontSize: '40pt'
    }
  });

class PaymentTransactions extends Component {

    constructor(props) {
      super(props);
      this.state = {
        startDate : moment().add(-1, 'month'),
        endDate: moment(),
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 1,
        totalPages: 0,
        message: '',
        agentList: [],
        payment_status: ['COLLECTED', 'PENDING'],
        payment_type: ['CASH', 'CHEQUE'],

        // filter
        filter_store: undefined,
        filter_status: undefined,
        filter_type: undefined,
        collectPaymentModal: null,
        columns : [
            { id: 'store_name', numeric: false, disablePadding: false, label: 'Store', sortable: true },
            { id: 'invoice_date', numeric: false, disablePadding: false, label: 'Invoice Date' , sortable: true },
            { id: 'invoice_no', numeric: false, disablePadding: false, label: 'Invoice No' , sortable: true },
            { id: 'amount', numeric: false, disablePadding: false, label: 'Amount', sortable: true  },
            { id: 'txn_date', numeric: false, disablePadding: false, label: 'Transaction Date', sortable: true  },
            { id: 'agent_name', numeric: false, disablePadding: false, label: 'Collected By', sortable: true  },
            { id: 'txn_type', numeric: false, disablePadding: false, label: 'Txn type' , sortable: true },
            { id: 'no', numeric: false, disablePadding: false, label: 'No', sortable: false  },
            { id: 'status', numeric: false, disablePadding: false, label: 'Status', sortable: true  },
            { id: 'actions', numeric: false, disablePadding: false, label: 'Actions' , sortable: false },
        ],
        order: 'desc',
        orderBy: 'invoice_date',
    }

      this.handleSelect = this.handleSelect.bind(this);

      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
      this.collectPayment = this.collectPayment.bind(this);
      this.postUpdate = this.postUpdate.bind(this);

      this.exportData = this.exportData.bind(this);
    }

    componentDidMount(){
        this.props.setTitle('Payment Transaction Status');
        this.fetchTotalPages();
        this.fetchAgentList();
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }

    fetchTotalPages(){
        PaymentService.getTotalCount(this.state.startDate, this.state.endDate)
        .then((data) => {
            this.setState({
                totalItems: data.count, 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }   
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage, true);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, true));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, false));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    fetchData(start, numberItems, silent = false){
        if(!silent)
            this.props.isLoading(true);
        let rows = [];
        let store = '', status= '', type = '';
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        if(this.state.filter_store){
            store = this.state.filter_store.map(function(store){
                return store.id;
            }).join(",");
        }
        
        if(this.state.filter_status){
            status = this.state.filter_status.map(function(t){
                return t;
            }).join(",");
        }
        if(this.state.filter_type){
            type = this.state.filter_type.map(function(t){
                return t;
            }).join(",");
        }

        PaymentService.getTransactions(start, numberItems, this.state.startDate, this.state.endDate, store, status, type, sort, direction)
        .then((data) => {
            console.log(data);
            if(data.transactions){
                let isAdmin = this.props.user.roles.includes(ROLES.ADMIN) || 
                                this.props.user.roles.includes(ROLES.STORE_MANAGEMENT) || 
                                this.props.user.roles.includes(ROLES.ACCOUNTS) || 
                                this.props.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || 
                                this.props.user.roles.includes(ROLES.ADMIN);
                data.transactions.forEach((t) => {
                    let u = this.state.agentList.filter(u => u.id === t.user_id)[0];
                    rows.push(<TransactionDetails 
                                key={t.id} 
                                user={u} 
                                transaction={t} 
                                isAdmin={isAdmin} 
                                collectPayment={this.collectPayment} 
                                showConfirmDialog={this.props.showConfirmDialog} 
                                closeConfirmDialog={this.props.closeConfirmDialog} 
                                showSnackBar={this.props.showSnackBar}/>);
                });
                this.setState({
                    current_rows: rows, message : data.transactions.length > 0 ? "" : "No Transactions"
                });
            }
            if(!silent)
                this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            if(!silent)
                this.props.isLoading(false);
        });
    }

    fetchAgentList(){
        UserService.getStoreList(0, 1000000, '', '', '', '0,1,2')
        .then((data) => {
            console.log(data);
            this.setState({ agentList: data.users });
            this.fetchData(0, this.state.numItemsPerPage);
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    filterResult(){
        this.fetchData(0, this.state.numItemsPerPage, true);
    }

    collectPayment(e, transaction, user){
        if(e)
            e.preventDefault();
        this.setState({collectPaymentModal: null}, ()=> {
            let collectPaymentModal = <CollectPayment transaction={transaction} user={user} agent_id={this.props.user.id} postUpdate={this.postUpdate} showConfirmDialog={this.props.showConfirmDialog} closeConfirmDialog={this.props.closeConfirmDialog} showSnackBar={this.props.showSnackBar}/>;
            this.setState({collectPaymentModal: collectPaymentModal});
        });
    }

    postUpdate(){
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, true);
    }

    exportData(){
        let store = '', status= '', type = '';
        if(this.state.filter_store){
            store = this.state.filter_store.map(function(store){
                return store.id;
            }).join(",");
        }
        
        if(this.state.filter_status){
            status = this.state.filter_status.map(function(t){
                return t;
            }).join(",");
        }
        if(this.state.filter_type){
            type = this.state.filter_type.map(function(t){
                return t;
            }).join(",");
        }
        PaymentService.getExportData(this.state.startDate, this.state.endDate, store, status, type)
        .then((data) => {

            if(data.transactions){
                let title = ["Sl. No","Store", "Invoice Date", "Invoice No", "Amount", "Transaction Date", "Collected By", "Txn type", "No", "Status" ];
                let exportData = [title];
                this.props.isLoading(true);
                data.transactions.forEach((transaction, index) => {
                    let transactionArray = [index + 1, transaction.store_name, getTimeInIST(transaction.invoice_date).format(format), transaction.invoice_no, transaction.amount, getTimeInIST(transaction.txn_date).format(format), transaction.agent_name, transaction.txn_type, transaction.no , transaction.status];
                    exportData.push(transactionArray);
                });
                if(exportData){
                    const wb = XLSX.utils.book_new();
                    const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                    XLSX.utils.book_append_sheet(wb, wsAll, 'Transactions');
                    XLSX.writeFile(wb, "Payment Transaction.xlsx");
                    this.props.isLoading(false);
                }
            }
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    render() {
        let message = this.state.message;
        return (
                <div className="">
                    <Paper className={this.props.classes.root} style={{width: "100%", paddingLeft: "5px", paddingRight: "5px", marginTop: 32}}>
                    <br />
                        <div style={{display: "inline-block", float: 'left'}}>
                            <div className="rangeContainer payment_transactions">
                                <div className="centerwrapper">
                                    <div className = "squareLabel fromLabel">From:</div>
                                    <div className = "square">
                                        <DatePicker 
                                            className="datePicker"
                                            selected={this.state.startDate}
                                            selectsStart
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            onChange={this.handleChangeStart}
                                            dateFormat={format_date_only} />
                                    </div>
                                    <div className = "squareLabel toLabel">To</div>
                                    <div className = "square">
                                        <DatePicker
                                            className="datePicker"
                                            selected={this.state.endDate}
                                            selectsEnd
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            onChange={this.handleChangeEnd}
                                            dateFormat={format_date_only}
                                        />
                                    </div>
                                    <div className = "square refresh-button">
                                        <Button onClick={(e) => { this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage, true)}}>SEARCH</Button>
                                    </div>
                                    <div className = "square refresh-button">
                                        <Button bsStyle="primary" onClick={this.exportData}>EXPORT</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{display: "inline-block", float: 'left', marginTop: "10px", minHeight: "50px"}}>
                            <div style={{float: 'left', marginRight: '10px', fontSize: 'larger'}}>
                                Filters:
                            </div>
                            <div style={{float: 'left', width: "300px", marginRight: '5px'}}>
                                <Typeahead
                                    id="typeahead-id-payment-store"
                                    onChange={(selected) => {
                                        this.setState({ "filter_store": selected }, () => this.filterResult() );
                                    }}
                                    options={this.state.agentList}
                                    labelKey={(option) => `${option.store_name} [${option.flat}]`}
                                    placeholder="Store Name"
                                    clearButton
                                    multiple />
                            </div>
                            <div style={{float:"left", width: "200px", marginRight: '5px'}}>
                                <Typeahead
                                    id="typeahead-id-payment-status"
                                    onChange={(selected) => {
                                        this.setState({ "filter_status": selected }, () => this.filterResult());
                                    }}
                                    options={this.state.payment_status}
                                    placeholder="Payment Status"
                                    clearButton
                                    multiple />
                            </div>
                            <div style={{float:"left", width: "200px", marginRight: '5px'}}>
                                <Typeahead
                                    id="typeahead-id-payment-type"
                                    onChange={(selected) => {
                                        this.setState({ "filter_type": selected }, () => this.filterResult());
                                    }}
                                    options={this.state.payment_type}
                                    placeholder="Payment Type"
                                    clearButton
                                    multiple />
                            </div>
                        </div>
                    { !this.props.loading && 
                        <div style={{display: "inline-block", width: "100%"}}>
                            {/* { this.state.current_rows.length > 0 &&
                                <Pager>
                                    <Pager.Item previous disabled={this.state.currentPageNumber  === 0}  eventKey="prev" onSelect={this.handleSelect} href="#">
                                        &larr; Previous Page {this.state.currentPageNumber  === 0 ? "" : this.state.currentPageNumber }
                                    </Pager.Item>
                                    <Pager.Item next disabled={this.state.currentPageNumber  === this.state.totalPages} eventKey="next" onSelect={this.handleSelect} href="#">
                                        Next Page {this.state.currentPageNumber  === this.state.totalPages ? "": this.state.currentPageNumber + 2} &rarr;
                                    </Pager.Item>
                                </Pager>
                            } */}
                                <div className="container" style={{ width: "100%", paddingLeft: "15px", minHeight: "400px"}}>
                                    <Table striped condensed hover responsive>
                                        <EnhancedTableHead
                                            order={this.state.order}
                                            orderBy={this.state.orderBy}
                                            onRequestSort={this.sortBy}
                                            rows ={this.state.columns} />
                                        <TableBody>
                                        {this.state.current_rows}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        rowsPerPageOptions={RowCountOptions}
                                        component="div"
                                        count={this.state.totalItems}
                                        rowsPerPage={this.state.numItemsPerPage}
                                        page={this.state.currentPageNumber}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                        {   message && 
                                            <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                                        }
                                </div>
                            {this.state.collectPaymentModal}
                        </div>
                    }
                    </Paper>
                </div>
        );
    }
}

class TransactionDetails extends Component {

    render(){
      const t = this.props.transaction;
      const u = this.props.user;
      const isAdmin = this.props.isAdmin;
      return (
        <tr>
            <td>{t.store_name}</td>
            <td>{getTimeInIST(t.invoice_date).format(format_fancy)}</td>
            <td>{t.invoice_no}</td>
            <td>{t.amount}</td>
            <td>{t.txn_date ? getTimeInIST(t.txn_date).format(format_fancy) : '-'}</td>
            <td>{t.agent_name ? t.agent_name : '-'}</td>
            <td>{t.txn_type ? t.txn_type : '-'}</td>
            <td>{t.no ? t.no : '-'}</td>
            <td>{t.status ? t.status : '-'}</td>
            <td>
                { isAdmin && t.status === 'PENDING' && t.invoice_no ?
                        <OverlayTrigger overlay={popover("Collect Payment")}>
                            <Glyphicon glyph="tags" onClick={(e) => this.props.collectPayment(e, t, u)} style={{marginLeft: "10px"}} /> 
                        </OverlayTrigger>
                        : ""
                }
                {   t.status === 'COLLECTED' && t.payment_no && t.payment_url ? 
                        <OverlayTrigger overlay={popover("View Payment Receipt")}>
                            <Glyphicon glyph="file" onClick={()=> window.open(t.payment_url, "_blank")}  style={{marginLeft: "10px"}} /> 
                        </OverlayTrigger>
                        : ""
                }
            </td>
        </tr>
      );
    }
}

export default withStyles(styles)(PaymentTransactions);